import React from 'react';
import { UIState } from '../../App';
import StandardButton from '../common/button/StandardButton';
import './IntroPanel.scoped.scss';

interface ComponentProps {
    uiState: UIState;
}

interface ComponentState {
    hasInitialized: boolean;
}


class IntroPanel extends React.Component<ComponentProps, ComponentState> {
    constructor(props: ComponentProps) {
        super(props);
        this.state = { hasInitialized: false };
    }

    didClickOnLearnMore = () => {
        window.open("https://www.unicef-irc.org/publications/pdf/What-Makes-Me_Core-Capacities-for-Living-and-Learning.pdf", '_blank')?.focus();
    }

    render() {
        let uiStateClass = (this.props.uiState === UIState.Intro) ? "" : "hidden";
        let hasInitialized = this.state.hasInitialized ? "" : "initialState";

        return (
            <div className={"introPanel " + uiStateClass}>
                <div className={"innerWrp " + hasInitialized}>
                    <div className="introTitle">
                        What <br className="lineJump" />Makes Me?
                    </div>
                    <div className="introText">Core Capacities for Living and Learning</div>
                    <div className="intro-downloadReportBtn">
                        <StandardButton buttonText="Download the report" buttonIconURL="/assets/downloadIconWhite.svg"
                            buttonIconWidth={20} buttonClickCallback={this.didClickOnLearnMore} isIntroButton={true}
                        ></StandardButton>
                    </div>
                </div>
            </div>
        )
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ hasInitialized: true });
        }, 300);
    }
}

export default IntroPanel;